import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
import { TaxService } from '../proxy/controlling/controllers/tax.service';
import { LocationService } from '@planning/proxy/planning/controllers/location.service';
FieldBuilder.setNamespace('Controlling');

export const CONTRACTTYPETAX_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('contractTypeId', 'Entity.ContractType', ContractTypeService)
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('taxId', 'Entity.Tax', TaxService)
    .displayFromNested('tax.name')
    .sortBy('tax.name')
    .build(),
  FieldBuilder.foreignKey('destinationLocationId', 'Entity.ContractTypeTax.DestinationLocation', LocationService)
    .display('name')
    .keyField('id')
    .build(),
];

export const CONTRACTTYPETAX_CONFIG = {
  entityName: 'ContractTypeTax',
  localizationKey: 'Controlling::Entity.ContractTypeTax',
  fields: CONTRACTTYPETAX_FIELDS,
  permission: 'ControllingContract.ContractTypeTaxes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
